import { Component, Input, HostBinding, QueryList, ElementRef, ViewChildren, ContentChildren, AfterContentInit, 
  ViewChild, Inject, PLATFORM_ID, Output, EventEmitter } from '@angular/core';
import { MktTabPanelComponent } from '../mkt-tab-panel/mkt-tab-panel.component';
import { MktSiteCatalystService } from 'src/app/core/services/mkt-site-catalyst.service';
import { isPlatformBrowser } from '@angular/common';

// For easy reference
const keys = {
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  enter: 13,
  space: 32
};

// Add or subtract depending on key pressed
const direction = {
  37: -1,
  38: -1,
  39: 1,
  40: 1
};

let inc = 0;

@Component({
  selector: 'mkt-tab-list',
  templateUrl: './mkt-tab-list.component.html',
  styleUrls: ['./mkt-tab-list.component.scss'],
  standalone: false
})
export class MktTabListComponent implements AfterContentInit {
  public activeTab: number;
  public isMobile: boolean = false;

  @HostBinding('attr.id') public hostId: string = 'mkt-' + inc++;

  @Input() public tabTitleProperty: string;
  @Input() public enableTagging: boolean = true;
  @Input() public scData: any;
  @Input() public scTabName: string[] = [];
  @Input() public taggingData: string[] = [];
  @Output() tabClick:EventEmitter<any> = new EventEmitter();

  @ViewChild('selectRef') private selectRef: ElementRef<HTMLSelectElement>;

  @ViewChildren('tabControl') public tabs: QueryList<ElementRef>;

  @ContentChildren(MktTabPanelComponent) public tabpanels: QueryList<MktTabPanelComponent> = new QueryList();

  constructor(
    public siteCatService: MktSiteCatalystService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    // this.hostId = `nav-tab-${nextId++}`;

    let si = setInterval(() => {
      if (!this.tabpanels) return;

      clearInterval(si);
      this.activateTab(0, false);
    }, 200);
  }

  ngAfterContentInit() {
    this.tabpanels.forEach((tabpanel, index) => {
      tabpanel.groupId = this.hostId;
      tabpanel.index = index;
    });
  }

  handleSelectValueChange(event) {
    this.activateTab(event.target.value, false);


    // The below code is to fix focus issue on older Android devices
    if (!this.selectRef || !this.selectRef.nativeElement) return;

    let selectElem = this.selectRef.nativeElement;

    let si = setInterval(() => {
      if (document.activeElement != selectElem) selectElem.focus();
      if (document.activeElement == selectElem) clearInterval(si);
    }, 100);
  }

  private tabTagging(tabNum) {

    if (!this.enableTagging) { return; }

    const data = Object.assign({}, this.scData);
    if (data) {
      data.pageName = this.scTabName[tabNum];
      data.localpageName = this.scTabName[tabNum];
      this.siteCatService.callSC('naAnalyticsPageView', data);
    }
    this.tabClick.emit(tabNum);
  }

  // When a tab is clicked, activateTab is fired to activate it
  clickEventListener(event, index) {

    this.activateTab(index, false);
  };

  // Handle keydown on tabs
  keydownEventListener(event, index) {
    switch (event.keyCode) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        this.focusLastTab();
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        this.focusFirstTab();
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        event.preventDefault();
        this.switchTabOnArrowPress(event, index);
        break;
    };
  };

  // Handle keyup on tabs
  keyupEventListener(event, index) {
    switch (event.keyCode) {
      case keys.left:
      case keys.right:
        this.switchTabOnArrowPress(event, index);
        break;
      case keys.enter:
      case keys.space:
        this.activateTab(index);
        break;
    };
  };

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  switchTabOnArrowPress(event, index) {
    let { keyCode } = event;
    let tabs = this.tabs.toArray();

    let newIndex = (index + tabs.length + direction[keyCode]) % tabs.length;

    this.activateTab(newIndex);
  };

  // Activates any given tab panel
  activateTab(tabIndex, setFocus = true) {
    // Deactivate all other tabs
    this.deactivateTabs();

    // Set activeTab variable
    this.activeTab = +tabIndex;

    // Make tab panel visible
    let panels = this.tabpanels.toArray();
    panels[this.activeTab].isSelected = true;

    // Browser specific code
    if (isPlatformBrowser(this.platformId)) {
      // call tagging for active Tab
      this.tabTagging(tabIndex);

      // Set focus when required
      if (setFocus) {
        let tabs = this.tabs.toArray();
        let tabElem = tabs[this.activeTab].nativeElement;
        tabElem.focus();
      }
    }
  };

  // Deactivate all tabs and tab panels
  deactivateTabs() {
    // let tabs = this.tabs.toArray();
    let panels = this.tabpanels.toArray();
    panels.forEach(panel => { panel.isSelected = false; });
  };

  // Make a guess
  focusFirstTab() {
    let tabs = this.tabs.toArray();
    tabs[0].nativeElement.focus();
  };

  // Make a guess
  focusLastTab() {
    let tabs = this.tabs.toArray();
    tabs[tabs.length - 1].nativeElement.focus();

  };
}
